module.exports = __webpack_public_path__ + "static/parade-2019-house04-59900e4a0c833c146a849b83f553fd48.jpg";